import React from 'react';
import BeatLoader from 'react-spinners/BeatLoader';

const PaymentLoader = ({ title = 'Paiement en cours', zIndex = 3 }) => {
  return (
    <div
      className={'h-full w-full absolute items-center justify-center text-center flex flex-col gap-6'}
      style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)', zIndex: zIndex }}
    >
      <BeatLoader
        color={'#C4EEB9'}
        loading={true}
        size={30}
        speedMultiplier={0.5}
      />
      {title}
    </div>
  );
};

export default PaymentLoader;
